var map = {
	"./1.png": 896,
	"./2.png": 897,
	"./3.png": 898,
	"./4.png": 899,
	"./5.png": 900,
	"./5.svg": 901,
	"./6.png": 902,
	"./7.png": 903,
	"./CloudGuard-Service.svg": 904,
	"./DNS.svg": 905,
	"./GoDown.png": 906,
	"./GoDown.svg": 907,
	"./GoTop.png": 908,
	"./GoTop.svg": 909,
	"./Group 420.png": 910,
	"./Group 420.svg": 911,
	"./Group 78.png": 912,
	"./Group 78.svg": 913,
	"./Group.png": 914,
	"./Insta.png": 915,
	"./ManagedService-Service.svg": 916,
	"./VPC-Service.svg": 917,
	"./VPS-Service.svg": 918,
	"./anjoman_s.png": 919,
	"./anjoman_s.svg": 920,
	"./bar.svg": 921,
	"./cloud-dns.svg": 922,
	"./contact.png": 923,
	"./contact.svg": 867,
	"./daneshbonyan.png": 924,
	"./daneshbonyan.svg": 925,
	"./ddos.svg": 926,
	"./discount.png": 927,
	"./discount.svg": 928,
	"./enamad-logo.png": 929,
	"./enamad-logo.svg": 930,
	"./facebook.png": 931,
	"./facebook.svg": 932,
	"./github.png": 933,
	"./github.svg": 934,
	"./insta.svg": 935,
	"./instagram.png": 936,
	"./instagram.svg": 937,
	"./linked.svg": 938,
	"./linkedin.png": 939,
	"./linkedin.svg": 940,
	"./new/xaas-instagram.png": 941,
	"./new/xaas-linkedin.png": 942,
	"./new/xaas-telegram.png": 943,
	"./new/xaas-twitter.png": 944,
	"./new/xaas-youtube.png": 945,
	"./nezam-senfi.png": 946,
	"./nezam-senfi.svg": 947,
	"./quote.png": 694,
	"./showMore.svg": 836,
	"./tweet.svg": 948,
	"./tweter.png": 949,
	"./twitter.png": 950,
	"./twitter.svg": 951,
	"./vps_icon2.png": 952,
	"./xaas-fab.png": 953,
	"./xaas-fab.svg": 954,
	"./xaas-occc.png": 955,
	"./xaas-occc.svg": 956,
	"./xaas-riasat-jomhoori.png": 957,
	"./xaas-riasat-jomhoori.svg": 958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1090;